import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable,Subject } from "rxjs";
import { tap, map } from 'rxjs/operators';
import { Router } from "@angular/router";

import { FvmsApiBaseService } from "./fvms.api.base.service";
import { FvmsApiCompanyService } from "./fvms.api.company.service";
import { FvmsCommonService } from "./fvms.common.service";
import { FvmsUserInfo } from "src/app/shared/vo/fvms.user.info";

@Injectable({providedIn: 'root'})
export class FvmsApiAuthService extends FvmsApiBaseService {
    storageNameUserInfo:string = "userInfo";
    subjectCurrentUser:Subject<any> = new Subject<any>();

    constructor(
        public http:HttpClient
        ,private router:Router
        ,private fvmsApiCompanyService:FvmsApiCompanyService
        ,private fvmsCommonService:FvmsCommonService
    ) {
        super(http);
    }

    getCurrentUserInfo():Observable<FvmsUserInfo>{
        return this.subjectCurrentUser.asObservable();
    }
    setCurrentUserInfo(currentUserInfo:FvmsUserInfo){
        this.subjectCurrentUser.next(currentUserInfo);
    }

    //사용자 정보 획득
    getLoginUserInfo():FvmsUserInfo{
        let userInfo = null;
        try{
            let strUserInfo = localStorage.getItem(this.storageNameUserInfo) || sessionStorage.getItem(this.storageNameUserInfo) || undefined;
            if(strUserInfo){
                // console.log("getLoginUserInfo",strUserInfo);
                userInfo = JSON.parse(strUserInfo);
                if(!userInfo["apiType"]){
                    userInfo["apiType"] = null;
                    sessionStorage.setItem(this.storageNameUserInfo,JSON.stringify(userInfo));
                }
            }
            // console.log("getLoginUserInfo",userInfo); // userInfo=null;
        }catch(e){
            console.error("FvmsApiAuthService","getLoginUserInfo",e);
        }
        return userInfo;
    }

    //로그인 체크
    loginCheck(userId:string,userPw:string,ipAccessDevice:string,typeAccessDevice:string="1"):Observable<any>{
        let url = this.getApiBaseUrl() + "/auth";
        url += "/login/check";

        let loginUserInfo = {
            "userId":userId
            ,"userPw":userPw
            ,"ipAccessDevice":ipAccessDevice
            ,"typeAccessDevice":typeAccessDevice
        };

        let bodyData = JSON.stringify(loginUserInfo);

        return this.http.post<any>(url,bodyData,{ headers : this.header });
    }

    loginTokenCheck(token:string,ipAccessDevice:string,typeAccessDevice:string="1"):Observable<any>{
        let url = this.getApiBaseUrl() + "/auth";
        url += "/login/token/check";

        let loginUserInfo = {
            "token":token
            ,"ipAccessDevice":ipAccessDevice
            ,"typeAccessDevice":typeAccessDevice
        };

        let bodyData = JSON.stringify(loginUserInfo);

        return this.http.post<any>(url,bodyData,{ headers : this.header });
    }

    //접속자 ip 가져오기
    getIpAccessDevice():Observable<any>{
        return this.http.jsonp("//api.ipify.org/?format=jsonp","callback").pipe(
            tap(ipInfo => {
                if(ipInfo){
                    let tmpUserInfo = this.getLoginUserInfo();
                    if(tmpUserInfo){
                        tmpUserInfo.ipAccessDevice = ipInfo.ip;
                        this.setCurrentUserInfo(tmpUserInfo);
                    }
                }
            })
        );
    }

    updateUserInfo(userInfo:any) {
        sessionStorage.setItem(this.storageNameUserInfo,JSON.stringify(userInfo));
    }

    //로그인 후 사용자 정보 저장
    setSessionUserInfo(userInfo:any,isAutoLogin:boolean){
        try{
            sessionStorage.removeItem(this.storageNameUserInfo);
            localStorage.removeItem(this.storageNameUserInfo);

            if(userInfo.userPw){
                delete userInfo.userPw;
            }
            if(!userInfo["apiType"]){
                userInfo["apiType"] = null;
            }
            if(!userInfo["showMapCluster"]){
                userInfo["showMapCluster"] = true
            }
            if(isAutoLogin){
                // localStorage.setItem(this.storageNameUserInfo,JSON.stringify(userInfo));
                sessionStorage.setItem(this.storageNameUserInfo,JSON.stringify(userInfo));
                this.setCompanyInfo(userInfo.companyId);
            }else{
                sessionStorage.setItem(this.storageNameUserInfo,JSON.stringify(userInfo));
                this.setCompanyInfo(userInfo.companyId);
            }
            this.setCurrentUserInfo(userInfo);
        }catch(ex){
            console.error("FvmsApiAuthService","setSessionUserInfo",ex);
        }
    }

    //로그아웃 서버 호출
    setSignOut(userId:string = "",ipAccessDevice:string,typeAccessDevice:string = "1"):Observable<any>{
        let url = this.getApiBaseUrl() + "/auth";
        url += "/logout";

        let loginUserInfo = {
            "userId":userId
            ,"ipAccessDevice":ipAccessDevice
            ,"typeAccessDevice":typeAccessDevice
        };

        let bodyData = JSON.stringify(loginUserInfo);

        return this.http.post<any>(url,bodyData,{ headers : this.header });
    }

    //로그아웃 처리
    signOut(){
        let userInfo = JSON.parse(JSON.stringify(this.getLoginUserInfo()));
        if(userInfo){
            this.setSignOut(userInfo.userId,userInfo.ipAccessDevice,userInfo.typeAccessDevice)
                .subscribe(apiResponse => {
                    sessionStorage.clear();
                    localStorage.clear();
                    this.setCurrentUserInfo(null);
                    this.router.navigate(["/fvms/auth/login/main"]);
                });
        }
    }

    checkSameId(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/auth";
        url += "/login/id/check";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(searchInfo));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    checkSameIds(userIds:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/auth";
        url += "/login/ids/check";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(userIds));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    resetUserPw(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/auth";
        url += "/login/pw/reset";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(searchInfo));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    private setCompanyInfo(userCompanyId:any){
        this.fvmsApiCompanyService.getOneCompanyTree(userCompanyId)
            .subscribe(response => {
                if(response.resultStatus === "ok"){
                    let companyInfo = response.resultValue;
                    this.fvmsCommonService.setCompanyInfo(companyInfo);
                }
            });
    }

    requestUserPwReset(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/auth";
        url += "/login/pw/lost/request";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(searchInfo));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    checkUserPwReset(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/auth";
        url += "/login/pw/lost/check";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(searchInfo));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }
}
